import { useState } from 'react';
import reactDom from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { Redirect } from 'react-router-dom';

import { getUserData } from '../../Redux/Selectors/UserSelectors';
import { getUserByID } from '../../Redux/Selectors/AllUsersSelectors';
import { setAllUsersDataByID } from '../../Redux/Actions/AllUsersActions';
import { rx } from '../../Redux/Actions/';
import { authRx } from '../../Redux/Actions/UserActions/thunk';
import { reset, deleteUser } from '../../API/User';

import { BrokerObjects } from '../../Components/BrokersObjects';
import { Profile } from '../../Components/Profile';
import { Modal } from '../../Components/UI/Modal';
import { ConfirmForm } from '../../Components/UI/Form';

import { recents } from '../../Components/RecentObjects';

import {
  profileFormConfig,
  confirmFormConfigs,
} from '../../Configs/FormConfigs';

import { constants } from '../../Configs/constants';

const {
  urls: { CONSOLE_USERS },
} = constants;

const defaultBrokerData = {
  name: '',
  phone: '',
  email: '',
  about: '',
};

export const ConfirmPortal = ({ open, entered, fn, handleSubmit, config }) => {
  return open
    ? reactDom.createPortal(
        <Modal open={open} closeFn={fn}>
          <ConfirmForm
            entered={entered}
            {...config}
            submitFn={handleSubmit}
            closeFn={fn}
          />
        </Modal>,
        document.getElementById('root'),
      )
    : null;
};

const BrokerProfilePage = ({ match }) => {
  const [confirmModalIndex, setConfirmModalIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [entered, setEntered] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();

  const { id } = match.params;
  const user = useSelector(getUserByID(id));
  const { user: userData } = useSelector(getUserData);
  const { avatarURL, gravatar } = user || { avatarURL: '', gravatar: '' };

  const { name, phone, whatsup, viber, email, about } =
    user || defaultBrokerData;

  const formdata = { name, phone, whatsup, viber, email, about };

  const handleClickControl = index => () => {
    setOpen(true);
    setConfirmModalIndex(index);
    setTimeout(() => setEntered(true), 100);
  };

  const handleCloseModal = e => {
    if (e) {
      if (e.target !== e.currentTarget) return;
    }
    setEntered(false);
    setConfirmModalIndex(null);
    setTimeout(() => setOpen(false), 100);
  };

  const handleSubmit = index => e => {
    e.preventDefault();
    e.nativeEvent.submitter.style.pointerEvents = 'none';
    const { tokenAccess, tokenRefresh } = userData;
    if (index === 0) {
      dispatch(
        rx(
          authRx,
          data => {
            if (data.data.data) {
              setTimeout(() => setEntered(false), 800);
              setTimeout(() => setOpen(false), 1000);
              setTimeout(() => {
                history.push('/console/brokere');
              }, 1100);
            }
          },
          deleteUser,
          tokenAccess,
          tokenRefresh,
          id,
        ),
      );
    }

    if (index === 1) {
      const body = JSON.stringify({ email });
      dispatch(
        rx(authRx, () => null, reset, tokenAccess, tokenRefresh, {
          id,
          body,
        }),
      );
    }
  };

  const controls = [
    {
      text: 'ištrinti brokeri',
      fn: handleClickControl(0),
      butType: 'red',
    },
    {
      text: 'Siųsti nauja slaptažodį',
      fn: handleClickControl(1),
      butType: 'gold',
    },
  ];

  return user ? (
    <>
      <Profile
        avatarURL={avatarURL}
        gravatar={gravatar}
        formdata={formdata}
        userData={userData}
        userId={id}
        setUserAction={setAllUsersDataByID}
        config={profileFormConfig}
        controls={controls}
      />
      <BrokerObjects data={recents} />
      <ConfirmPortal
        open={open}
        entered={entered}
        fn={handleCloseModal}
        handleSubmit={handleSubmit(confirmModalIndex)}
        config={confirmFormConfigs[confirmModalIndex]}
      />
    </>
  ) : (
    <Redirect to={CONSOLE_USERS} />
  );
};

export default BrokerProfilePage;
